import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = {
  key: 4,
  class: "img-crossfade"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "wrapper" }
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = {
  key: 0,
  style: {"width":"100%","padding":"20px","color":"#fff","background":"red","margin":"40px 0 20px","font-weight":"bold"}
}
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "actions" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "wrapper" }
const _hoisted_22 = { class: "content" }
const _hoisted_23 = { class: "title" }
const _hoisted_24 = { class: "actions" }
const _hoisted_25 = {
  class: "wrapper",
  style: {"height":"100%"}
}
const _hoisted_26 = {
  class: "content",
  style: {"display":"flex","flex-direction":"column","height":"inherit"}
}
const _hoisted_27 = { style: {"flex":"1","padding":"20px","text-align":"center"} }
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  class: "ts",
  style: {"margin":"0 20px 20px 20px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sb_nav_bar = _resolveComponent("sb-nav-bar")!
  const _component_sb_carousel = _resolveComponent("sb-carousel")!
  const _component_sb_footer = _resolveComponent("sb-footer")!
  const _component_GDialog = _resolveComponent("GDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style['container'])
    }, [
      _createVNode(_component_sb_nav_bar, { title: _ctx.title }, null, 8, ["title"]),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style['container__main-area'])
      }, [
        _createVNode(_component_sb_carousel, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouselArr, (carouselItem, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "mySlides fade",
                key: i
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(carouselItem, (singleItem, j) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                    (singleItem.testoGrande)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "t",
                          innerHTML: singleItem.testoGrande[_ctx.$i18n.locale]
                        }, null, 8, _hoisted_1))
                      : _createCommentVNode("", true),
                    (singleItem.testo)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "ts",
                          innerHTML: singleItem.testo[_ctx.$i18n.locale]
                        }, null, 8, _hoisted_2))
                      : _createCommentVNode("", true),
                    (singleItem.testoCustom)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          innerHTML: singleItem.testoCustom[_ctx.$i18n.locale]
                        }, null, 8, _hoisted_3))
                      : _createCommentVNode("", true),
                    (singleItem.img)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 3,
                          style: {"width":"100%"},
                          src: singleItem.img.src,
                          alt: singleItem.img.alt[_ctx.$i18n.locale]
                        }, null, 8, _hoisted_4))
                      : _createCommentVNode("", true),
                    _hoisted_5,
                    _hoisted_6,
                    _hoisted_7,
                    (singleItem.fade)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(singleItem.fade, (itemToFade, p) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "img-cont",
                              key: p
                            }, [
                              (itemToFade.testoGrande)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "t",
                                    innerHTML: itemToFade.testoGrande[_ctx.$i18n.locale]
                                  }, null, 8, _hoisted_9))
                                : _createCommentVNode("", true),
                              (itemToFade.testo)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "ts",
                                    innerHTML: itemToFade.testo[_ctx.$i18n.locale]
                                  }, null, 8, _hoisted_10))
                                : _createCommentVNode("", true),
                              (itemToFade.testoCustom)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 2,
                                    innerHTML: itemToFade.testoCustom[_ctx.$i18n.locale]
                                  }, null, 8, _hoisted_11))
                                : _createCommentVNode("", true),
                              (itemToFade.img)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 3,
                                    style: {"width":"100%"},
                                    src: itemToFade.img.src,
                                    alt: itemToFade.img.alt[_ctx.$i18n.locale]
                                  }, null, 8, _hoisted_12))
                                : _createCommentVNode("", true),
                              _hoisted_13
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]))
            }), 128))
          ]),
          _: 1
        })
      ], 2),
      _createVNode(_component_sb_footer, null, {
        default: _withCtx(() => [
          _createTextVNode(" Comperio srl - Reso 24 © rel. " + _toDisplayString(_ctx.release) + " - " + _toDisplayString(_ctx.$t("message.hello")), 1)
        ]),
        _: 1
      })
    ], 2),
    _createVNode(_component_GDialog, {
      modelValue: _ctx.patronOk,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.patronOk) = $event)),
      persistent: "",
      width: "100%",
      class: _normalizeClass(_ctx.$style['patron-ok'])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("message.returningitems")), 1),
            ((_ctx.libIsClosed === 0) && _ctx.actualPatron)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.$t("message.biblioopened")), 1))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  innerHTML: _ctx.$t('message.retruningmessage', {btnName: _ctx.$t('message.opennreturncounter'), seconds: _ctx.originalReturnLockTimerValue})
                }, null, 8, _hoisted_18))
          ]),
          _createElementVNode("div", _hoisted_19, [
            (_ctx.libIsClosed >= 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn--confirm",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openReturnLock && _ctx.openReturnLock(...args))),
                  disabled: _ctx.isOpenReturnDisabled
                }, _toDisplayString((_ctx.returnLockTimerValue >= 0) ? `Chiusura in ${_ctx.returnLockTimerValue}s` : _ctx.$t("message.opennreturncounter")), 9, _hoisted_20))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn btn--alert",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
            }, _toDisplayString(_ctx.$t("message.cancel")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "class"]),
    _createVNode(_component_GDialog, {
      modelValue: _ctx.dialogKo,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogKo) = $event)),
      persistent: "",
      width: "100%",
      class: _normalizeClass(_ctx.$style['dialog-ko'])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.patronErrorTitle), 1),
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.$style['dialog-ko__user'])
            }, _toDisplayString(_ctx.patronErrorMessage), 3)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
              class: "btn btn--confirm",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
            }, "OK")
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "class"]),
    (_ctx.imgCountdown && _ctx.textCountdown)
      ? (_openBlock(), _createBlock(_component_GDialog, {
          key: 0,
          modelValue: _ctx.dialogCountdown,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialogCountdown) = $event)),
          persistent: "",
          fullscreen: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("img", {
                    src: _ctx.imgCountdown,
                    style: {"height":"100%","max-width":"100%","object-fit":"cover"}
                  }, null, 8, _hoisted_28)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$style['countdown-cont-progress']),
                  style: {"margin":"20px 0"}
                }, [
                  _createElementVNode("div", {
                    ref: "countdown-progress",
                    class: _normalizeClass(_ctx.$style['countdown-progress'])
                  }, null, 2)
                ], 2),
                _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.textCountdown), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}